import CompanyAvailabilityCalendarHeaderCell from './CompanyAvailabilityCalendarHeaderCell';

export default CompanyAvailabilityCalendarHeaderCell;
